import React, { useState, useEffect } from 'react'
import { Pane, Switch, TextInputField, Text } from 'evergreen-ui'
import BtnDefault from '../../Components/BtnDefault';
const ActivityTypeForm = ({
  save, activityType = null, handleEdit
}) => {
  const [name, setName] = useState('')
  const [active, setActive] = useState(true)
  const [isEdit, setEdit] = useState(false)

  useEffect(() => {
    if (activityType && !isEdit) {
      setName(activityType.name)
      setActive(activityType.active)
      setEdit(true)
    }
  }, [activityType, isEdit])

  const handleSave = (e) => {
    e.preventDefault()
    if (isEdit) {
      handleEdit({
        name, active, __id__: activityType.__id__
      })
    }
    else {
      save({ name, active })
    }
  }

  return (
    <form onSubmit={(e) => handleSave()}>
      <Pane flex={1} alignItems="center" marginTop={10}>
        <TextInputField
          label='Descrição do tipo de atividade'
          description=""
          name='desc' placeholder='Descrição' value={name} onChange={({ target }) => setName(target.value)} />
        <Text>
          Ativo
          <Switch
            height={24}
            checked={active}
            onChange={({ target }) => setActive(target.checked)}
            marginBottom={16}
          />
        </Text>

        <BtnDefault
          type='submit'
          disabled={!name}
          onClick={handleSave}
          iconBefore='tick'
          height={40} appearance="primary"> {
            !isEdit ? 'Cadastrar' : 'Editar'
          } </BtnDefault>
      </Pane>
    </form>
  )

}

export default ActivityTypeForm